const enableBiometricsScreen = 'enable-biometrics-screen';
const enableBiometricsModal = 'enable-biometrics-modal';
const biometricsTestIds = {
  enableBiometricsScreen: enableBiometricsScreen,
  enableBiometricsScreenHeader: enableBiometricsScreen + '-header',
  enableBiometricsScreenDescription: enableBiometricsScreen + '-description',
  enableBiometricsScreenEnableButton: enableBiometricsScreen + '-enable-button',
  enableBiometricsScreenNotNowButton:
    enableBiometricsScreen + '-not-now-button',

  enableBiometricsModal: enableBiometricsModal,
  enableBiometricsModalHeader: enableBiometricsModal + '-header',
  enableBiometricsModalDescription: enableBiometricsModal + '-description',
  enableBiometricsModalSystemSettingsBtn:
    enableBiometricsModal + '-open-system-settings-btn',
  enableBiometricsModalNotNowBtn: enableBiometricsModal + '-not-now-btn',
};

export default biometricsTestIds;
